import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccessControl } from "../types";

interface ACLState {
  list: AccessControl[];
  selectedTenant: string | null;
}

const initialState: ACLState = {
  list: [],
  selectedTenant: null,
};

const aclSlice = createSlice({
  name: "acl",
  initialState,
  reducers: {
    setList(state, action: PayloadAction<AccessControl[]>) {
      state.list = action.payload;
    },
    setSelectedTenant(state, action: PayloadAction<{ tenantCode: string }>) {
      // const selectedTenant = state.list.find(
      //   (el) => el.tenantCode === action.payload.tenantCode
      // );
      state.selectedTenant = action.payload.tenantCode || null;
    },
  },
});

export const { setList, setSelectedTenant } = aclSlice.actions;

export default aclSlice.reducer;
